module.exports = __webpack_public_path__ + "static/img/050502.89f2ccc2.png";